/**
 * Размер стороны квадрата для qrCode
 */
export const defaultQrSize = 140;
